/** Local until `@brushfire/types` on the CI shared branch exports this union. */
export type QuestionBankLastUsedSurveyType = 'sign_up' | 'direct' | 'regular' | 'dynamic'

const LAST_USED_SURVEY_LABELS: Record<QuestionBankLastUsedSurveyType, string> = {
  sign_up: 'Sign-Up Survey',
  direct: 'Direct Survey',
  regular: 'Regular Survey',
  dynamic: 'Dynamic Survey',
}

/** Read-only card line. Null when the question has never been published. */
export function questionBankLastUsedForLabel(
  surveyType: QuestionBankLastUsedSurveyType | null | undefined,
): string | null {
  if (!surveyType) return null
  const surveyLabel = LAST_USED_SURVEY_LABELS[surveyType]
  if (!surveyLabel) return null
  return `Last used for \u2013 ${surveyLabel}`
}
